import 'core-js/modules/es6.object.assign';
import * as React from "react";
import * as ReactDOM from "react-dom";
import './index.scss';

import * as Scroll from 'react-scroll'; // Imports all Mixins

import { BrowserRouter, NavLink, Link, Route, Switch , Redirect} from 'react-router-dom'
import { RouteComponentProps, withRouter, matchPath } from 'react-router-dom'




type NavState = {
    readonly scrolled : boolean
    readonly collapsed : boolean
}

class Nav extends React.Component<{}, NavState> {
     constructor(props : {}) {
        super(props);

        this.state = {
            scrolled: false,
            collapsed: true
        };
    }

    handleScroll : () => void = () => {
        this.setState({ ... this.state, scrolled : (document.documentElement.scrollTop || document.body.scrollTop) > 15 })
    }

    public componentDidMount() : void {
        window.addEventListener('scroll', this.handleScroll);
    }

    public componentWillUnmount() : void {
        window.removeEventListener('scroll', this.handleScroll);
    }

    public toggleCollapse() : void {
        this.setState({ ... this.state, collapsed : !this.state.collapsed})
    }

    public render() : JSX.Element {
        const containerCls = "navbar navbar-toggleable-sm navbar-light fixed-top navbar-inverse" + 
            ( this.state.scrolled ? " navbar-scrolled" : "" )

        const navCls = "navbar-nav ml-auto" + 
            ( this.state.collapsed ? " collapsed" : "" )

        return (
            <nav className={ containerCls }>
                <div className="container">
                    <button className="navbar-toggler navbar-toggler-right" onClick={() => this.toggleCollapse() }>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <a className="navbar-brand" onClick={() => Scroll.animateScroll.scrollToTop()}>
                        <img src={require('./images/logo_variant2_white.svg')} />
                    </a>
                    <div className={ navCls }>
                        <Scroll.Link onClick={() => this.toggleCollapse()} activeClass="active" className="nav-item nav-link" to="functions" offset={-65} smooth={true}>Funktioner</Scroll.Link>
                        <Scroll.Link onClick={() => this.toggleCollapse()} activeClass="active" className="btn btn-outline-secondary text-white" to="contact" offset={-65} smooth={true}>Kontakt os</Scroll.Link>
                    </div>
                </div>
            </nav>
        );
    }
}


class App extends React.Component<{}, {}> {
    protected hero: null | HTMLElement = null

    public componentDidMount() : void {
        window.addEventListener('orientationchange', this.calcHeight.bind(this));
        this.calcHeight()

        
    }
    public componentWillUnmount() : void {
        window.removeEventListener('orientationchange');
    }

    public calcHeight() : void {
        if ('ontouchstart' in window ) {
            setTimeout(() => {
                const vH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                if (this.hero !== null) {
                    this.hero.setAttribute("style", "height:" + vH + "px;");
                }
            }, 300)            
        }        
    }

    public renderMainPage() : JSX.Element {
        return (
            <div>
                <Nav />

                <section id="hero">
                    <div className="jumbotron text-white" ref={elem => this.hero = elem}>
                    
                    <div className="container">
                        <div className="col-sm-6">
                        <div className="row">
                        <h1 className="display-3">Din portal til en effektiv arbejdsdag</h1>
                        <p className="lead">Hold styr på alle dine opgaver, kunder, dokumenter, deadlines og data på én platform</p>
                        <p className="lead">
                            <Scroll.Link className="btn btn-outline-secondary btn-md" to="functions" smooth={true} offset={-65}>Læs mere</Scroll.Link>
                        </p>
                        </div>
                    </div>
                    </div>

                    
                    </div>
                
                    <div className="scroll-button-container"><div className="scroll-button demo"><Scroll.Link activeClass="active" className="nav-item nav-link" to="functions" offset={-65} smooth={true}><span></span></Scroll.Link></div></div>
                </section>
                <Scroll.Element name="functions" id="functions">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="display-4 text-center">
                                    Én platform til at styre kommunikation, materiale <br />
                                    og processer på tværs af virksomheden
                                </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="offset-md-1 col-md-5 offset-lg-1 col-lg-4">
                                    <p className="text-center">
                                        <img src={require('./images/subtasks.png')} />  
                                    </p>
                                    <h5 className="text-center">Workflow management</h5>
                                    <p className="text-center">Cerno kan opsættes med arbejdsgange, fra simple checklister til komplicerede workflows på tværs af flere medarbejdere, som sikrer korrekt og ensartet behandling - hver gang.</p>
                                
                            </div>
                            <div className="col-md-5 col-lg-4 offset-lg-2">
                                    <p className="text-center">
                                        <img src={require('./images/files.png')} />  
                                    </p>
                                    <h5 className="text-center">Dokumentstyring og -arkiv</h5>
                                    <p className="text-center">Alle sager, kunder og produkter har et note- og dokumentarkiv, hvor alle typer filer kan gemmes og deles. Filer, noter og historik er altid er ved hånden - også for kolleger.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="offset-md-1 col-md-5 offset-lg-1 col-lg-4">
                                    <p className="text-center">
                                        <img src={require('./images/integration.png')} />  
                                    </p>
                                    <h5 className="text-center">Data samlet ét sted</h5>
                                    <p className="text-center">Cerno samler data fra andre systemer, så I kun har brug for at gå ét sted hen. Se betalingshistorik fra økonomi-systemet, emailkorrespondance, og meget andet.</p>
                                
                            </div>
                            <div className="col-md-5 col-lg-4 offset-lg-2">
                                    <p className="text-center">
                                        <img src={require('./images/documents.png')} />  
                                    </p>
                                    <h5 className="text-center">Dan, gem og send dokumenter</h5>
                                    <p className="text-center">Dan kontrakter, breve og emails og send dem med det samme. Cernos dokumentskabeloner kan opsættes til det hele og udfyldes automatisk. </p>
                                
                            </div>
                        </div>
                    </div>
                </Scroll.Element>

                <Scroll.Element name="case-dkkapital-head" id="case-dkkapital-head">

                </Scroll.Element>

                <Scroll.Element name="case-dkkapital" id="case-dkkapital">


                <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <h1>
                                    <small>Case: Leasing- og finansiering</small><br />
                                    DK Kapital A/S
                                </h1>

                                <p className="lead">DK Kapital A/S er et leasing- og finansieringsselskab med base i Odense. </p>

                                <p className="lead">Virksomheden har specialiseret sig i fleksible og individuelle løsninger til biler og campingvogne i alle prisklasser.</p>

                        
                            </div>
                            <div className="col-lg-6">
                            <div className="quote">
                            <img className="quotation-mark" src={require('./images/quote-dark-gray.svg')} />
                            Cerno har i den grad forandret vores virksomhed. Vi har al information samlet ét sted, som alle har adgang til. Vi har fået en papirløs og mere effektiv administration til glæde for både medarbejdere og kunder.
                            </div>

                            <div className="quote-person">
                                <img className="portrait" src={require('./images/torben125.jpg')} />

                                Torben Skovlund Nielsen,<br/>
                                Direktør, DK Kapital A/S
                            </div>
                            </div>

                        </div>
                    </div>
                    </Scroll.Element>

                    <Scroll.Element name="case-dkkapital-solution" id="case-dkkapital-solution">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-6">
                        <h4 className="text-center">
                            Udfordringer
                        </h4>
                        <ul>
                        <li><span className="pe-7s-attention" /> Som finansieringsvirksomhed er der mange krav fra myndigheder, som skal overholdes på hver enkel sag.</li>
                        <li><span className="pe-7s-attention" /> Papirbaseret administration gør samarbejde om sagerne på tværs af afdelinger og medarbejdere svært. </li>
                        <li><span className="pe-7s-attention" /> Forskelligartet sagsbehandling afhængig af medarbejder</li>
                        <li><span className="pe-7s-attention" /> Ressourcekrævende oplæring af nye medarbejdere og vikarer</li>
                        
                        </ul>

                        </div>
                        
                        <div className="col-lg-6">
                        <h4 className="text-center">
                            Hvad har Cerno gjort?
                        </h4>
                        <ul>
                        <li><span className="pe-7s-check"></span> Etablering af papirløs administration</li>
                            <li><span className="pe-7s-check"></span> Detaljerede opgavelister sikrer ensartet og korrekt behandling af alle sager</li>
                            <li><span className="pe-7s-check"></span> Håndtering af alle trin i processen ét sted fra første kundekontakt til kontraktens udløb </li>
                            <li><span className="pe-7s-check"></span> Breve, mails og kontrakter dannes med et enkelt klik i Cerno</li>                            
                            <li><span className="pe-7s-check"></span> Cerno aflæser al indgående korrespondance og tildeler automatisk kontrakter med stregkoder til de korrekte sager </li>                 
                        </ul>

                        </div>
                        
                        </div>

                    </div>


                </Scroll.Element>


                <Scroll.Element name="case-hea-head" id="case-hea-head">
                </Scroll.Element>



                <Scroll.Element name="case-hea" id="case-hea">


                <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <h1>
                                    <small>Case: Ejendomsadministration</small><br />
                                    Hovedstadens Ejendomsadministration A/S
                                </h1>

                                <p className="lead">Hovedstadens Ejendomsadministration A/S har mere end 30 års erfaring med ejendomsinvestering og administration. </p>

                                <p className="lead">I dag er det 2. generation af den familieejede virksomhed, der står for driften af både erhvervsudlejning og boligudlejning, primært i hovedstadsområdet.</p>

                        
                            </div>
                            <div className="col-lg-6">
                            <div className="quote">
                            <img className="quotation-mark" src={require('./images/quote-dark-gray.svg')} />
                            Vi behandler alle vores sager i Cerno. Cerno sikrer, at vores arbejdsgange udføres korrekt hver gang, og at vi hele tiden har det fulde overblik over alle sager og deres status. Cerno er blevet en naturlig del af vores arbejdsdag
                            </div>

                            <div className="quote-person">
                                <img src={require("./images/lejemaaldk.png")} className="portrait"/>

                                Kenneth Søndergaard, Koncernchef og ejer, <br />Hovedstadens Ejendomsadministration A/S
                            </div>
                            </div>

                        </div>
                    </div>
                    </Scroll.Element>

                    <Scroll.Element name="case-hea-solution" id="case-hea-solution">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-6">
                        <h4 className="text-center">
                            Udfordringer
                        </h4>
                        <ul>
                        <li><span className="pe-7s-attention" /> Virksomheden ønskede overblik over igangværende sager og arbejdsbelastning for at kunne prioritere og planlægge bedre</li>
                        <li><span className="pe-7s-attention" /> Medarbejdere brugte tid på et finde data i flere forskellige systemer</li>
                        <li><span className="pe-7s-attention" /> Der var ingen måde at tilgå kollegers sager, når de var fraværende </li>
                        <li><span className="pe-7s-attention" /> Virksomheden ønskede at opnå ét sted, hvor al information om sager var samlet og kunne tilgås</li>
                        </ul>

                        </div>
                        
                        <div className="col-lg-6">
                        <h4 className="text-center">
                            Hvad har Cerno gjort?
                        </h4>
                        <ul>
                        <li><span className="pe-7s-check"></span> Cerno sikrer ensartet og korrekt behandling af alle sager </li>
                        <li><span className="pe-7s-check"></span> Medarbejdere og ledelse har overblik over alle sager, udeståender og to dos</li>
                        <li><span className="pe-7s-check"></span> Cerno henter information fra andre systemer, fx økonomisystemet, så medarbejderne kun skal gå ét sted hen</li>
                        <li><span className="pe-7s-check"></span> Mails, noter og dokumenter på opgaver og lejere ligger samlet ét sted, som alle hurtigt kan tilgå </li>
                        </ul>

                        </div>
                        
                        </div>

                    </div>


                </Scroll.Element>


                <Scroll.Element name="why-cerno" id="why-cerno"><div className="overlay">
                    <div className="container">

                        <div className="row">
                            <div className="col-12">
                                <h1 className="display-3 text-center">Hvorfor vælge Cerno?</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 offset-sm-1 col-sm-4 offset-md-0 col-md-3">
                                <h1 className="display-1 text-center"><span className="pe-7s-check"></span></h1>
                                <h5 className="text-center">Bedre resultater</h5>
                                <p className="text-center">Forbedr effektivitet &amp; resultater på tværs af virksomheden </p>
                            </div>
                            <div className="col-6 offset-sm-2 col-sm-4 offset-md-0 col-md-3">
                                <h1 className="display-1 text-center"><span className="pe-7s-display1"></span></h1>
                                <h5 className="text-center">Få overblik</h5>
                                <p className="text-center">Strukturerede arbejdsgange sikrer kvalitet og overblik</p>
                            </div>
                            <div className="col-6 offset-sm-1 col-sm-4 offset-md-0 col-md-3">
                                <h1 className="display-1 text-center"><span className="pe-7s-global"></span></h1>
                                <h5 className="text-center">Adgang overalt</h5>
                                <p className="text-center">Alt er samlet ét sted – med adgang på mødet, hjemme eller i toget</p>
                            </div>
                            <div className="col-6 offset-sm-2 col-sm-4 offset-md-0 col-md-3">
                                <h1 className="display-1 text-center"><span className="pe-7s-like2"></span></h1>
                                <h5 className="text-center">Brugervenligt</h5>
                                <p className="text-center">Intuitivt at anvende – kræver ingen dyre konsulenttimer</p>
                            </div>
                        </div>
                    </div></div>
                </Scroll.Element>
                
                <Scroll.Element name="contact" id="contact" className="text-white">
                    <div className="container">
                        
                        <div className="row">
                            <div className="col-12">
                                <h1 className="display-3 text-center">Kontakt os</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-4">
                                <h1 className="display-2 text-center"><span className="pe-7s-phone"></span></h1>
                                <h5 className="text-center">Telefon</h5>
                                <h5 className="text-center small">21 49 02 65</h5>
                            </div>
                            <div className="col-sm-4">
                                <h1 className="display-2 text-center"><span className="pe-7s-paper-plane"></span></h1>
                                <h5 className="text-center">E-mail</h5>
                                <h5 className="text-center small"><a href="mailto:info@cerno.dk" className="text-white">info@cerno.dk</a></h5>
                            </div>
                            <div className="col-sm-4">
                                <h1 className="display-2 text-center"><span className="pe-7s-map-marker"></span></h1>
                                <h5 className="text-center">Besøg os</h5>
                                <h5 className="text-center small">Bøgevej 17<br />2900 Hellerup</h5>
                            </div>
                        </div>
                    </div>
                </Scroll.Element>
                
                <Scroll.Element name="footer" id="footer" className="text-white">
                    <div className="row">
                        <div className="col-12">
                            <p className="display-3 text-center small">
                                <Link to="/privacy" onClick={() =>
                                     window.scroll(0, 0)
                                } >Privacy policy</Link>
                            </p>
                        </div>
                    </div>
                </Scroll.Element>
            </div>
        )
    }

    public renderPolicyNav() : JSX.Element {
        const containerCls = "navbar navbar-toggleable-sm navbar-light fixed-top navbar-inverse" + 
            ( true ? " navbar-scrolled" : "" )

        const navCls = "navbar-nav ml-auto" + 
            ( true ? " collapsed" : "" )

        return <nav className={ containerCls }>
            <div className="container">
                <button className="navbar-toggler navbar-toggler-right">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <a className="navbar-brand" onClick={() => Scroll.animateScroll.scrollToTop()}>
                    <img src={require('./images/logo_variant2_white.svg')} />
                </a>
                <div className={ navCls }>
                    <Link className="btn btn-outline-secondary text-white" to="/">Back to cerno.dk</Link>                    
                </div>
            </div>
        </nav>
    }

    public renderPrivacyPolicy() : JSX.Element {
        return <div>
            { this.renderPolicyNav() }
            <div id="privacy-policy">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                
                            <h1>Privacy Policy</h1>
                            <p>Last updated: 01/23/2018</p>
                            <p>Cerno ApS operates <a href="http://cerno.dk">http://cerno.dk</a> (the "Site"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site.</p>
                            <p>We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.</p>

                            <h3>Information Collection And Use</h3>
                            <p>While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").</p>

                            <h3>Log Data</h3>
                            <p>Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data").</p>
                            <p>This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>

                            <h3>Access to information from third party services </h3>
                            <p>Customers of Cerno has the possibility of logging into third party services such as cloud-based mail accounts (Office 365 and Google Apps) through the Site. </p>
                            <p>By logging into your mail service through the Site, we gain access to read and search the content of your mail account. By choosing to save a mail on the Site, the content of the mail is stored on our servers and can be accessed by other users logged in to the Site.</p>

                            <h3>Cookies</h3>
                            <p>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>
                            <p>Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.</p>

                            <h3>Security</h3>
                            <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>

                            <h3>Changes To This Privacy Policy</h3>
                            <p>This Privacy Policy is effective as of 01/23/2018 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p>
                            <p>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>
                            <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</p>

                            <h3>Contact Us</h3>

                            <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@cerno.dk">info@cerno.dk</a>.</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    }


    public render() : JSX.Element {
        return (
            <div>
                <Switch>
                <Route exact path="/" render={ (p : RouteComponentProps<{}>) => {
                    return this.renderMainPage() 
                }}/>
                <Route exact path="/privacy" render={ (p : RouteComponentProps<{}>) => {
                    return this.renderPrivacyPolicy()
                }} />
                <Redirect to="/"/>
                </Switch>
                
            </div>
        )
    }
}

ReactDOM.render(
    <BrowserRouter><App /></BrowserRouter>
,
    document.getElementById("example")
);



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/index.tsx